import { render, staticRenderFns } from "./SCouponpack.vue?vue&type=template&id=799cde5a&scoped=true"
import script from "./SCouponpack.vue?vue&type=script&lang=js"
export * from "./SCouponpack.vue?vue&type=script&lang=js"
import style0 from "./SCouponpack.vue?vue&type=style&index=0&id=799cde5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799cde5a",
  null
  
)

export default component.exports